import Calendar from "@/utils/calendar";

export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '批次包编码',
        dataIndex: 'pkgCode',
        key: 'pkgCode',
    },
    {
        title: '商品图片',
        dataIndex: 'productImg',
        key: 'productImg',
        scopedSlots: {
            customRender: 'productImgAction'
        }
    },
    {
        title: '商品SKU',
        dataIndex: 'shopProductSku',
        key: 'shopProductSku'
    },
    {
        title: '所在库区',
        dataIndex: 'regionCode',
        key: 'regionCode',
        scopedSlots: {
            customRender: 'regionName'
        }
    },
    {
        title: '废弃件数',
        dataIndex: 'amount',
        key: 'amount',
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
    },
    {
        title: '操作人',
        dataIndex: 'createrName',
        key: 'createrName'
    },
]